"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Cookies from "js-cookie";
import { checkBannerCookie, setBannerCookie } from "./PromotionBannerMethods";
import { PromotionBanner } from "@/components/terra/component/PromotionBanner/PromotionBanner";
import useCheckOneTrust from "./useCheckOneTrust";
import { processLinkUrl } from "@/lib/formatters/formatLinks";
import PersonalizationExperience from "../Personalization/PersonalizationExperience";
// import Link from "next/link"

const PromotionBannerConnector = t0 => {
  const $ = _c(54);
  const {
    promotionBanner,
    lang
  } = t0;
  const invisibleBaseline = promotionBanner?.invisibleBaseline || null;
  const richTextDetails = promotionBanner?.richTextDetails || null;
  const header = promotionBanner?.header || null;
  const redisplayDays = promotionBanner?.redisplayDays || null;
  const cookieName = promotionBanner?.sys?.id;
  const updatedAt = promotionBanner?.sys?.publishedAt || null;
  const [hasDismissedBanner, setHasDismissedBanner] = useState(true);
  const {
    hasAcceptedOneTrust
  } = useCheckOneTrust(Cookies);
  let t1;
  let t2;
  if ($[0] !== cookieName || $[1] !== updatedAt) {
    t1 = () => {
      if (typeof window !== "undefined") {
        if (checkBannerCookie(Cookies, cookieName, updatedAt)) {
          setHasDismissedBanner(true);
        } else {
          setHasDismissedBanner(false);
        }
      }
    };
    t2 = [setHasDismissedBanner, updatedAt, cookieName];
    $[0] = cookieName;
    $[1] = updatedAt;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== cookieName || $[5] !== redisplayDays || $[6] !== updatedAt) {
    t3 = () => {
      setBannerCookie(Cookies, cookieName, updatedAt, redisplayDays);
      setHasDismissedBanner(true);
    };
    $[4] = cookieName;
    $[5] = redisplayDays;
    $[6] = updatedAt;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleDismiss = t3;
  let t4;
  if ($[8] !== lang || $[9] !== promotionBanner?.cta) {
    t4 = promotionBanner?.cta ? {
      destination: processLinkUrl(promotionBanner?.cta?.urlString ? promotionBanner?.cta?.urlString : promotionBanner?.cta?.destination ? promotionBanner?.cta?.destination : promotionBanner?.cta?.dynamicPageReference ? promotionBanner?.cta?.dynamicPageReference?.slug : promotionBanner?.cta, lang),
      label: promotionBanner?.cta?.textLabel || promotionBanner?.cta?.linkText,
      type: "link",
      primary: promotionBanner?.cta?.isPrimary || true
    } : null;
    $[8] = lang;
    $[9] = promotionBanner?.cta;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const formattedCta = t4;
  const t5 = richTextDetails?.json;
  let t6;
  if ($[11] !== t5) {
    t6 = documentToReactComponents(t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const formattedDetails = t6;
  const hasPersonalization = promotionBanner?.ntExperiencesCollection?.items?.length > 0;
  let t7;
  if ($[13] !== handleDismiss || $[14] !== hasAcceptedOneTrust || $[15] !== hasDismissedBanner || $[16] !== hasPersonalization || $[17] !== lang || $[18] !== promotionBanner?.ntExperiencesCollection) {
    t7 = hasPersonalization ? formattedPromoBannerExperiences(promotionBanner?.ntExperiencesCollection, lang, handleDismiss, hasAcceptedOneTrust, hasDismissedBanner) : null;
    $[13] = handleDismiss;
    $[14] = hasAcceptedOneTrust;
    $[15] = hasDismissedBanner;
    $[16] = hasPersonalization;
    $[17] = lang;
    $[18] = promotionBanner?.ntExperiencesCollection;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const formattedExperiences = t7;
  const t8 = promotionBanner?.sys?.id;
  const t9 = promotionBanner?.sys?.id;
  let t10;
  if ($[20] !== t9) {
    t10 = {
      id: t9
    };
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== formattedDetails || $[23] !== hasPersonalization || $[24] !== richTextDetails?.json) {
    t11 = hasPersonalization ? {
      detailsJson: richTextDetails?.json
    } : {
      details: formattedDetails
    };
    $[22] = formattedDetails;
    $[23] = hasPersonalization;
    $[24] = richTextDetails?.json;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = promotionBanner?.startDate;
  const t13 = promotionBanner?.endDate;
  let t14;
  if ($[26] !== promotionBanner) {
    t14 = formatPromoCardFields(promotionBanner);
    $[26] = promotionBanner;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== formattedCta || $[29] !== formattedExperiences || $[30] !== handleDismiss || $[31] !== hasAcceptedOneTrust || $[32] !== hasDismissedBanner || $[33] !== header || $[34] !== invisibleBaseline || $[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t8) {
    t15 = {
      id: t8,
      sys: t10,
      header,
      cta: formattedCta,
      ...t11,
      handleClose: handleDismiss,
      hasAcceptedOneTrust,
      hasDismissedBanner,
      startDate: t12,
      endDate: t13,
      invisibleBaseline,
      ...t14,
      ntExperiencesCollection: formattedExperiences
    };
    $[28] = formattedCta;
    $[29] = formattedExperiences;
    $[30] = handleDismiss;
    $[31] = hasAcceptedOneTrust;
    $[32] = hasDismissedBanner;
    $[33] = header;
    $[34] = invisibleBaseline;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t8;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  const PromoBannerFields = t15;
  if (hasPersonalization) {
    const t16 = promotionBanner?.sys?.id;
    let t17;
    if ($[42] !== PromoBannerFields) {
      t17 = {
        ...PromoBannerFields
      };
      $[42] = PromoBannerFields;
      $[43] = t17;
    } else {
      t17 = $[43];
    }
    const t18 = `${promotionBanner?.sys?.id}`;
    let t19;
    if ($[44] !== t16 || $[45] !== t17 || $[46] !== t18) {
      t19 = <PersonalizationExperience BaselineComponent={PromotionBanner} id={t16} value={t17} key={t18} />;
      $[44] = t16;
      $[45] = t17;
      $[46] = t18;
      $[47] = t19;
    } else {
      t19 = $[47];
    }
    return t19;
  }
  const t16 = promotionBanner?.sys?.id;
  let t17;
  if ($[48] !== PromoBannerFields) {
    t17 = {
      ...PromoBannerFields
    };
    $[48] = PromoBannerFields;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const t18 = `${promotionBanner?.sys?.id}`;
  let t19;
  if ($[50] !== t16 || $[51] !== t17 || $[52] !== t18) {
    t19 = <PromotionBanner id={t16} value={t17} key={t18} />;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
};
export default PromotionBannerConnector;

// Entries created before the promo card fields existed have null values, so
// apply the same defaults the Contentful fields use for new entries.
const formatPromoCardFields = banner => ({
  theme: banner?.theme || "Yellow",
  displayVariant: banner?.displayVariant || "Banner",
  displayDelay: banner?.displayDelay ?? 0,
  teaser: banner?.teaser || null,
  cardImage: banner?.cardImage?.image?.url ? {
    url: banner.cardImage.image.url,
    width: banner.cardImage.image.width,
    height: banner.cardImage.image.height,
    altText: banner.cardImage.altText || "",
    focusArea: banner.cardImage.focusArea
  } : null,
  promoCode: banner?.promoCode || null,
  promoCodeLabel: banner?.promoCodeLabel || null,
  dismissLabel: banner?.dismissLabel || null,
  finePrintJson: banner?.finePrint?.json || null
});
const formattedPromoBannerExperiences = (experiences, lang, handleDismiss, hasAcceptedOneTrust, hasDismissedBanner) => {
  // Format CTA for variants and keep variant payload minimal (id, header, cta, detailsJson only).
  // The Ninetailed SDK JSON.stringifies baseline/variant for view-tracking; large payloads cause "Invalid string length".
  if (!experiences?.items?.length) return null;
  return {
    items: experiences?.items?.map(exp => ({
      ...exp,
      ntVariantsCollection: {
        items: exp?.ntVariantsCollection?.items?.map(variant => ({
          id: variant?.sys?.id,
          sys: variant?.sys,
          header: variant?.header,
          handleClose: handleDismiss,
          hasAcceptedOneTrust: hasAcceptedOneTrust,
          hasDismissedBanner: hasDismissedBanner,
          ...(variant?.richTextDetails?.json ? {
            detailsJson: variant?.richTextDetails?.json
          } : {
            details: variant?.details
          }),
          ...formatPromoCardFields(variant),
          cta: variant?.cta ? {
            destination: processLinkUrl(variant?.cta?.urlString ? variant?.cta?.urlString : variant?.cta?.destination ? variant?.cta?.destination : variant?.cta?.dynamicPageReference ? variant?.cta?.dynamicPageReference?.slug : variant?.cta, lang),
            label: variant?.cta?.textLabel || variant?.cta?.linkText,
            type: "link"
          } : null
        }))
      }
    }))
  };
};